import { render, staticRenderFns } from "./on-tag-dashboard.vue?vue&type=template&id=62c0d1bd"
import script from "./on-tag-dashboard.vue?vue&type=script&lang=js"
export * from "./on-tag-dashboard.vue?vue&type=script&lang=js"
import style0 from "./on-tag-dashboard.vue?vue&type=style&index=0&id=62c0d1bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports